import { createFileRoute } from "@tanstack/react-router"
import { QueryBoundary, TitleQueryBoundary } from "~/components/query-boundary"
import PageLoading from "~/components/ui/page-loading"
import { ChatView } from "~/features/chat/components/chat-view"
import { ChatHeader } from "~/features/chat/components/chat-header"
import type { PeerType } from "@apps/gwservice/types"

export const Route = createFileRoute("/chat")({
  validateSearch: (search) => {
    return {
      peerId: Number(search.peerId),
      peerType: search.peerType as PeerType
    }
  },
  component: Page,
})

function Page() {
  const { peerId, peerType } = Route.useSearch()

  return <div className="flex flex-col h-dvh">
    <TitleQueryBoundary>
      <ChatHeader peerId={Number(peerId)} peerType={peerType as PeerType} />
    </TitleQueryBoundary>
    <QueryBoundary loadingFallback={<PageLoading noHeader />}>
      <ChatView peerId={Number(peerId)} peerType={peerType as PeerType} />
    </QueryBoundary>
  </div>
}
